import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Select,
  Switch,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { useSnapSiteConfigEditContext } from '@ui/features/snap-site-config/screens/edit/context/hook';
import { get, useFormContext } from 'react-hook-form';

export function FixedDiscountForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();
  const { discountCodes } = useSnapSiteConfigEditContext();

  const discountCodeFieldPath = fieldPath('discountCode');
  const discountCodeFieldError = get(
    form.formState.errors,
    discountCodeFieldPath,
  );
  const allowFallbackFieldPath = fieldPath('allowFallback');

  return (
    <>
      <FormControl isInvalid={!!discountCodeFieldError} isRequired>
        <FormLabel htmlFor={discountCodeFieldPath}>Discount Code:</FormLabel>

        <Select
          {...form.register(discountCodeFieldPath)}
          id={discountCodeFieldPath}
        >
          {discountCodes.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </Select>

        <ErrorMessage
          name={discountCodeFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl>
        <Flex alignItems="center" gap={2} mb={1}>
          <Switch
            id={allowFallbackFieldPath}
            {...form.register(allowFallbackFieldPath)}
          />
          <FormLabel htmlFor={allowFallbackFieldPath} mb={0}>
            Allow Fallback
          </FormLabel>
        </Flex>
        <FormHelperText>
          When enabled, passes down to the next price strategy if quantity
          exceeds this strategy's maximum quantity break.
        </FormHelperText>
      </FormControl>
    </>
  );
}
